import React from 'react'
import PropTypes from 'prop-types'
import { LogicGateSVG } from './LogicGateSymbol.style'

const ORLogicGate = (props) => (
  <LogicGateSVG width={40} height={32} viewBox="0 0 34 26" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill="#687585"
        d="M2.999 0l8.45.002v.002l.225.002A26.34 26.34 0 0134 13.002a26.342 26.342 0 01-22.55 13H3a25.688 25.688 0 002.554-6H0v-2h6l.001.157c.34-1.666.517-3.391.517-5.157s-.178-3.49-.517-5.158L6 8.002H0v-2h5.554A25.688 25.688 0 002.999 0z"
        className="selection"
      />
      <text
        fill="#FFF"
        fontFamily="Arial-BoldMT, Arial"
        fontSize={9}
        fontWeight="bold"
      >
        <tspan x={11.75} y={16}>
          {'OR'}
        </tspan>
      </text>
    </g>
  </LogicGateSVG>
)

export default ORLogicGate

ORLogicGate.propTypes = {
  selected: PropTypes.bool,
}
